/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AllowedRecipientFacility } from './AllowedRecipientFacility';
import {
    AllowedRecipientFacilityFromJSON,
    AllowedRecipientFacilityFromJSONTyped,
    AllowedRecipientFacilityToJSON,
    AllowedRecipientFacilityToJSONTyped,
} from './AllowedRecipientFacility';

/**
 * 
 * @export
 * @interface GetAllowedRecipients200Response
 */
export interface GetAllowedRecipients200Response {
    /**
     * List of allowed recipient facilities
     */
    data?: Array<AllowedRecipientFacility>;
}

/**
 * Check if a given object implements the GetAllowedRecipients200Response interface.
 */
export function instanceOfGetAllowedRecipients200Response(value: object): value is GetAllowedRecipients200Response {
    return true;
}

export function GetAllowedRecipients200ResponseFromJSON(json: any): GetAllowedRecipients200Response {
    return GetAllowedRecipients200ResponseFromJSONTyped(json, false);
}

export function GetAllowedRecipients200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllowedRecipients200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(AllowedRecipientFacilityFromJSON)),
    };
}

export function GetAllowedRecipients200ResponseToJSON(json: any): GetAllowedRecipients200Response {
    return GetAllowedRecipients200ResponseToJSONTyped(json, false);
}

export function GetAllowedRecipients200ResponseToJSONTyped(value?: GetAllowedRecipients200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(AllowedRecipientFacilityToJSON)),
    };
}

